function updateCartOffer() {
  const offerText = document.getElementById('dynamic-special-offer-text');
  const offerBlock = document.getElementById('dynamic-special-offer');

  if (!offerText || !offerBlock) return;

  const threshold = parseFloat(offerBlock.dataset.threshold);

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const total = cart.items_subtotal_price / 100;

      if (total >= threshold) {
        offerText.textContent =
          'Gefeliciteerd! Je komt in aanmerking voor gratis verzending!';
      } else {
        const remaining = (threshold - total).toFixed(2);
        offerText.textContent =
          `Voeg meer toe voor gratis verzending. Nog €${remaining} nodig.`;
      }
    });
}

// Init bij paginalaad
document.addEventListener('DOMContentLoaded', updateCartOffer);

// Luister naar algemene cart events (meeste themes gebruiken dit)
document.addEventListener('cart:updated', updateCartOffer);
document.addEventListener('cart:refresh', updateCartOffer);

// Fallback: detecteer clicks op add-to-cart knoppen
document.addEventListener('click', function(e) {
  if (e.target.closest('button[type="submit"][name="add"]')) {
    setTimeout(updateCartOffer, 500);
  }
});